'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgApple = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "100%", height: "100%", viewBox: "0 0 16 19", fill: "currentColor" }, props),
    React__default['default'].createElement("g", { fillRule: "evenodd" },
        React__default['default'].createElement("path", { d: "M12.86 9.883A4.208 4.208 0 0 1 14.91 6.34a4.425 4.425 0 0 0-3.469-1.842c-1.46-.15-2.874.858-3.618.858-.758 0-1.903-.843-3.136-.818A4.632 4.632 0 0 0 .798 6.866c-1.68 2.858-.427 7.058 1.183 9.367.806 1.132 1.747 2.395 2.98 2.35 1.205-.049 1.655-.754 3.11-.754 1.442 0 1.864.754 3.121.726 1.294-.02 2.109-1.137 2.887-2.278a9.29 9.29 0 0 0 1.32-2.64C13.86 13 12.862 11.522 12.86 9.884M10.487 2.98A4.11 4.11 0 0 0 11.455 0a4.337 4.337 0 0 0-2.788 1.416 3.912 3.912 0 0 0-.994 2.87 3.588 3.588 0 0 0 2.814-1.307" })))); };

exports.default = SvgApple;
//# sourceMappingURL=index.js.map
